// Please don't change this, this is the dictionary from ag-grid library
export enum AgSortDirection {
	ASC = 'asc',
	DESC = 'desc',
	NONE = 'none'
}
